const TopLeaderBoardBanner = 'TopLeaderBoardBanner';
const Menu = 'Menu';
const ProductGridSetting = 'ProductGridSetting';

const enabled = 'enabled';

const linkModule = 'linkModule';
const linkImage = 'linkImage';
const topLeaderBoardBanner = 'topLeaderBoardBanner';
const imageSetting = 'imageSetting';

const menu = 'menu';
const roots = 'roots';

const buttonThemeUuid = 'buttonThemeUuid';
const displayProductDescription = 'displayProductDescription';
const displayRRP = 'displayRRP';
const display2ndCurrencyPrice = 'display2ndCurrencyPrice';
const displayProductReview = 'displayProductReview';
const displayProductPromotionTag = 'displayProductPromotionTag';
const gridSetting = 'gridSetting';

const featuredProducts = 'featuredProducts';
const titleTextColor = 'titleTextColor';

export {
  TopLeaderBoardBanner,
  Menu,
  ProductGridSetting,
  linkImage,
  linkModule,
  topLeaderBoardBanner,
  imageSetting,
  menu,
  roots,
  enabled,
  buttonThemeUuid,
  displayProductDescription,
  displayRRP,
  display2ndCurrencyPrice,
  displayProductReview,
  displayProductPromotionTag,
  gridSetting,
  featuredProducts,
  titleTextColor,
};
